<template>
  <div class="ai-section">
    <div class="section-title">
      Target Remedy Dates
    </div>

    <div
        class="compact-row remedy-row"
        v-for="item in items"
        :key="item.label"
    >
      <span>
        {{ item.label }}
        <em v-if="item.percent !== null">({{ item.percent }}%)</em>
      </span>

      <strong>{{ formatNumber(item.value) }}</strong>
    </div>

    <div class="warning-box">
      <i class="fa fa-exclamation-triangle"></i>
      {{ insight }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RemedyDatesBlock',

  props: {
    items: Array,
    insight: String,
    formatNumber: Function
  }
};
</script>

<style scoped>
.ai-section {
  border-top: 1px solid #e1e1e1;
  padding-top: 14px;
  margin-bottom: 22px;
}

.section-title {
  margin-bottom: 12px;
  color: #111;
  font-size: 14px;
  font-weight: 900;
}

.compact-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #333;
  font-size: 12px;
  padding: 9px 0;
  border-bottom: 1px solid #e8e8e8;
}

.compact-row:last-child {
  border-bottom: 0;
}

.compact-row strong {
  color: #111;
}

.compact-row em {
  color: #777;
  font-size: 11px;
  font-style: normal;
}

.remedy-row:last-of-type strong {
  color: #f32929;
}

.warning-box {
  margin-top: 12px;
  padding: 10px;
  background: #fff3f3;
  border-left: 4px solid #f32929;
  color: #9e1c1c;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}
</style>
